export const DEFAULT_UNITS_QUERY = "/portal/v1/units";

export const statuses = [
  { value: false, label: "Available" },
  { value: true, label: "Occupied" }
];

export const unitStatus = (occupied: boolean) =>
  occupied ? "Occupied" : "Available";

export const UNIT_ORIGIN_PARAM = "from";
export const LISTINGS_ORIGIN = "listings";

export const unitDetailsPath = (
  propertyId: number | undefined,
  unitId: number,
  { fromListings = false, tab }: { fromListings?: boolean; tab?: string } = {}
) => {
  const params = new URLSearchParams();
  if (tab) params.set("tab", tab);
  if (fromListings) params.set(UNIT_ORIGIN_PARAM, LISTINGS_ORIGIN);
  const query = params.toString();
  const path = `/properties/${propertyId}/units/${unitId}`;
  return query ? `${path}?${query}` : path;
};
